<a
  mat-button
  href="{{ faqUrl }}"
  target="_blank"
  rel="noopener"
  tabIndex="0"
  data-testid="header-faq"
></a>
